import controller from './yearly-dialog.controller';

export default {
  controller,
  template: require('./yearly-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/yearly-info/yearly-dialog.component.ts